import api from './api';
import { LinhaDoTempoRastreio, ListaEventosRastreio, ResumoRastreio } from '../types/rastreioEntrega';

export interface FiltroEventosRastreio {
  desde?: string;
  ate?: string;
  direcao?: string;
  provedor?: string;
  instancia?: string;
  apenasProblemas?: boolean;
  limiteAtrasoMs?: number;
  pagina?: number;
  porPagina?: number;
}

export const rastreioEntregaService = {
  getResumo: async (desde: string, ate?: string): Promise<ResumoRastreio> => {
    const { data } = await api.get('/rastreio-entrega/resumo', { params: { desde, ate } });
    return data.data;
  },
  getEventos: async (filtro: FiltroEventosRastreio): Promise<ListaEventosRastreio> => {
    const { data } = await api.get('/rastreio-entrega/eventos', { params: filtro });
    return data.data;
  },
  getPorApiMessageId: async (apiMessageId: string): Promise<LinhaDoTempoRastreio> => {
    const { data } = await api.get(`/rastreio-entrega/api/${encodeURIComponent(apiMessageId)}`);
    return data.data;
  },
  getPorMensagemId: async (mensagemId: string): Promise<LinhaDoTempoRastreio> => {
    const { data } = await api.get(`/rastreio-entrega/mensagem/${encodeURIComponent(mensagemId)}`);
    return data.data;
  }
};
